import { combineReducers } from 'redux';
import byId from './byId';
import metadata from './metadata';
import idList from './idList';

export default combineReducers({
  byId,
  metadata,
  idList,
});



// WEBPACK FOOTER //
// ./app/reducers/notifications/index.js